import { render, staticRenderFns } from "./SettingsStagePointsForWin.vue?vue&type=template&id=21927f28&"
import script from "./SettingsStagePointsForWin.vue?vue&type=script&lang=js&"
export * from "./SettingsStagePointsForWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports